const validate = values => {
	const errors = {}
	if (!values.guarantor_type) {
		errors.guarantor_type = 'Este campo es obligatorio'
	}
	return errors
}

export default validate



/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsGuarantorForm.js
 **/